import DisplayListingAnalitics from './DisplayListingAnalitics.component';

export default DisplayListingAnalitics;